import { ESignRecipient } from '@monetize/types/app';
import { ReactNode, useCallback } from 'react';
import { useResendQuoteEsign } from '../api/cpqService';
import { MBox, MText } from '../components/Monetize';
import { useConfirmModal } from '../services/confirmModal';

export const useQuoteResendEsign = (quoteId: string) => {
  const { showConfirmModal, setModalLoading, closeModal } = useConfirmModal();
  const { mutateAsync: resendQuoteEsign } = useResendQuoteEsign({
    meta: { showErrorToast: true },
  });

  const onResendQuote = useCallback(
    async (pendingSigners?: ESignRecipient[]) => {
      const onYes = async () => {
        setModalLoading(true);
        try {
          await resendQuoteEsign({ quoteId });
        } catch (err) {
          // pass
        }
        setModalLoading(false);
        closeModal();
      };

      let description: string | undefined =
        'The esign email will be resent to the current signer(s).';
      let content: ReactNode = null;
      if (pendingSigners?.length) {
        description = undefined;
        content = (
          <>
            <MText fontSize="sm" fontWeight="600">
              The following signers will be resent the eSign email:
            </MText>
            {pendingSigners.map(({ id, name, email }) => (
              <MBox py="2" key={id}>
                <MText fontWeight="400" color="tGray.darkPurple">
                  {name}
                </MText>
                <MText fontSize="xs" fontWeight="400" color="tGray.darkPurple">
                  {email}
                </MText>
              </MBox>
            ))}
          </>
        );
      }

      showConfirmModal({
        title: 'Are you sure you want to resend the Esign email?',
        description,
        content,
        onYes,
        yesBtnProps: {
          variant: 'primary',
        },
        noBtnProps: {
          variant: 'cancel',
        },
        yesButton: 'Send',
        noButton: 'Close',
      });
    },
    [closeModal, quoteId, resendQuoteEsign, setModalLoading, showConfirmModal],
  );

  return { onResendQuote };
};
